import gql from 'graphql-tag'
import { CCItem } from './fragments'

export default gql`
mutation updateCCItem($id: ID, $categoryId: ID, $categoryImgs: CCCategoryImgInput) {
	cashAssist {
		updateCCRoute(id: $id, fields: { categoryImgs: $categoryImgs }) {
			...CCItem
		}
	}
}
${CCItem}
`
